/* Diamond Domain - product video thumbnails (Sep 2026).
   Shopify generates every video thumbnail on a flat #EBEBEB grey while all of
   the product photography sits on pure white, so each video read as a darker
   square until someone clicked it. The videos themselves open on white - only
   the generated poster is grey - so rather than re-uploading a poster for each
   of the several hundred videos in the catalogue, every video borrows the still
   photo next to it in its own metal group. Same ring, same metal, same white
   background, and it keeps working for products added later.

   Two places show a video thumbnail and BOTH need it:
     1. the big poster inside the gallery       (desktop grid and mobile carousel)
     2. the small thumbnail strip under it      (hidden on desktop, VISIBLE on mobile)
   Fixing only the first left mobile still grey.

   Delete this file and its line in layout/theme.liquid to revert. */
(function () {
  var GREY = 'preview_images'; // Shopify's generated video thumbnails live here
  var HERO = 'Diagonal'; // the hero angle, and the one the videos open on

  function urlOf(img) {
    return (img.getAttribute('src') || '') + (img.getAttribute('srcset') || '');
  }

  // 1. the large poster inside each video tile
  function swapPosters() {
    var slides = document.querySelectorAll('.product-gallery__media-slide');
    var lastPhoto = null;
    var lastHero = null;

    for (var i = 0; i < slides.length; i++) {
      var photo = slides[i].querySelector('.product-gallery__media--image img');
      if (photo) {
        lastPhoto = photo;
        if ((photo.currentSrc || photo.getAttribute('src') || '').indexOf(HERO) > -1) {
          lastHero = photo;
        }
        continue;
      }

      var poster = slides[i].querySelector('.deferred-media__poster img');
      if (!poster || poster.getAttribute('data-dd-poster')) continue;

      var source = lastHero || lastPhoto;
      if (!source) continue;

      var src = source.currentSrc || source.getAttribute('src');
      if (!src) continue;

      // srcset would otherwise win over the src we are about to set
      poster.removeAttribute('srcset');
      poster.removeAttribute('data-srcset');
      poster.removeAttribute('sizes');
      poster.setAttribute('src', src);
      poster.setAttribute('data-dd-poster', '1');
    }
  }

  // 2. the thumbnail strip - this is the one mobile shows
  function swapThumbnails() {
    var thumbs = document.querySelectorAll('.product-single__thumbnail');
    var lastPhoto = null;
    var lastHero = null;

    for (var i = 0; i < thumbs.length; i++) {
      var img = thumbs[i].querySelector('img');
      if (!img) continue;

      if (urlOf(img).indexOf(GREY) === -1) {
        lastPhoto = img;
        if ((img.getAttribute('src') || '').indexOf(HERO) > -1) lastHero = img;
        continue;
      }
      if (img.getAttribute('data-dd-thumb')) continue;

      var source = lastHero || lastPhoto;
      if (!source) continue;

      var srcset = source.getAttribute('srcset');
      var sizes = source.getAttribute('sizes');
      var src = source.getAttribute('src');

      // both are photos at the same size, so the whole responsive set carries over
      if (srcset) img.setAttribute('srcset', srcset);
      else img.removeAttribute('srcset');
      if (sizes) img.setAttribute('sizes', sizes);
      if (src) img.setAttribute('src', src);
      img.setAttribute('data-dd-thumb', '1');
    }
  }

  function run() {
    swapPosters();
    swapThumbnails();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // photos load lazily, so currentSrc may only settle after load
  window.addEventListener('load', run);

  // the gallery is re-rendered on variant change; re-apply to the new nodes.
  // only childList is observed, so setting src above cannot retrigger this.
  var host = document.querySelector('.product-single__wrapper') || document.body;
  if (host && window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(run, 120);
    }).observe(host, {childList: true, subtree: true});
  }
})();